import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { ApplicationState } from '@/state/root.models'
import { RestApiService } from '@/services'
import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { jsonToQueryString } from '@/utils'
import ActionTypes from '../constants'
import {
  GetTransactionsPayload,
  TransactionsResponse,
  TransactionState,
} from '../models'

import { TRANSACTIONS } from './api.routes'
import { TransactionsActions } from '../slices/index.slices'

const restApiService: RestApiService = Container.get(RestApiService)

export const getAllTransactionsThunk = createAsyncThunk(
  ActionTypes.GET_ALL_TRANSACTIONS,
  async (payload: GetTransactionsPayload, thunkAPI) => {
    try {
      // The walletType is only used to show the right table
      const { xlsx, walletType, ...queries } = payload
      const { auth } = thunkAPI.getState() as ApplicationState

      if (!xlsx) {
        thunkAPI.dispatch(TransactionsActions.setIsloadingAction(true))
      }

      thunkAPI.dispatch(setLoadingFullAction(true))

      restApiService.requestParams = {
        method: 'GET',
        endpoint: TRANSACTIONS.FIND_ALL,
        queries: jsonToQueryString(queries),
      }

      const response: TransactionsResponse = await restApiService.getData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      if (response.status && response.status !== 200) {
        const message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')

        thunkAPI.dispatch(
          setSnackbarAction({
            message,
            open: true,
            variant:
              response?.status && response?.status !== 200
                ? 'error'
                : 'success',
          }),
        )
      }

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const getAllTransactionsExtraReducer = (
  builder: ActionReducerMapBuilder<TransactionState>,
) => {
  builder.addCase(
    getAllTransactionsThunk.fulfilled,
    (state, { payload, meta }) => {
      const { xlsx } = meta?.arg

      state.isLoading = false
      state.transactions = xlsx ? state.transactions : payload.docs
      state.pagination = xlsx
        ? state.pagination
        : {
            ...state.pagination,
            total: payload.total,
            pages: payload.pages,
            page: payload.page,
            limit: payload.limit,
          }
    },
  )
  builder.addCase(getAllTransactionsThunk.rejected, (state) => {
    state.isLoading = false
  })
}

export default getAllTransactionsExtraReducer
